<template>
  <v-card class="d-flex flex-column h-100">
    <!-- Search Field -->
    <div class="px-2 pt-5 flex-grow-0">
      <validation-observer>
        <validated-text-field
          v-model="query"
          autofocus
          :label="$t('title.search')"
          prepend-icon="mdi-magnify"
          clearable
          rules="max:49"
          maxlength="49"
          :dense="dense"
          :loading="isSearching"
        />
      </validation-observer>
    </div>
    <v-divider />

    <!-- Scope Selector -->
    <v-tabs
      v-model="mode"
      fixed-tabs
      class="pa-0 flex-grow-0"
      :dense="dense"
    >
      <v-tab>
        {{ $t('label.search_this_day') }}
      </v-tab>
      <v-tab>
        {{ $t('label.search_all_days') }}
      </v-tab>
    </v-tabs>
    <v-divider />

    <!-- No Results View -->
    <div
      v-if="resultsByDate.size === 0"
      class="align-center text-center pa-5 py-8"
    >
      <!-- No Query -->
      <p
        v-if="!isSearching && query.length < 3"
        class="mb-0 text--secondary"
      >
        {{ $t('label.enter_x_characters_to_search', [3]) }}
      </p>
      <!-- Searching -->
      <p
        v-else-if="isSearching"
        class="text--secondary"
      >
        {{ $t('placeholder.searching') }}
      </p>
      <!-- Not Found for this day -->
      <template v-else-if="mode===0">
        <p class="text--secondary">
          {{ $t('label.no_results_for_this_day') }}
        </p>
        <v-btn
          text
          outlined
          small
          @click="mode=1"
        >
          {{ $t('button.search_all_days') }}
        </v-btn>
      </template>
      <!-- Not Found otherwise -->
      <p
        v-else
        class="mb-0 text--secondary"
      >
        {{ $t('label.no_results') }}
      </p>
    </div>

    <!-- Reservations List -->
    <guest-results-list
      v-else
      :reservations="resultsByDate"
      @close="$emit('close')"
    />
  </v-card>
</template>

<script lang='ts'>

import Vue from 'vue';
import Reservation from '@/model/Reservation';
import GuestResultsList from '@/components/views/guests/GuestResultsList.vue';
import { SearchType } from '@/services/search';

export default Vue.extend({
  name: 'SearchList',
  components: { GuestResultsList },
  data() {
    return {
      query: '',
      mode: 0,
    };
  },
  computed: {
    resultsByDate(): Map<Date, Reservation[]> {
      return this.mode === 0
        ? this.$tstore.getters['search/searchDayReservationsByDate']
        : this.$tstore.getters['search/searchAllReservationsByDate'];
    },
    dense(): boolean {
      return this.$vuetify.breakpoint.xsOnly;
    },
    isSearching(): boolean {
      return this.$tstore.getters['search/isSearching'];
    },
  },
  watch: {
    query() {
      const query = this.query ?? '';
      this.$tstore.dispatch('search/search', { query, type: SearchType.AllReservations });
    },
  },
});

</script>
